// extracted by mini-css-extract-plugin
module.exports = {"ThemeGeneral":"Themes_ThemeGeneral__3ENJJ","ThemeDark":"Themes_ThemeDark__1sjFb","ThemeLight":"Themes_ThemeLight__1MtPh"};